export default {
  address: [
    'user-input',
    'map',
    'highway',
    'underground',
  ],
  'about-object': [
    'rent-part-house',
    'common/cadastral-number',
    'settlement-name',
    'build-year',
    'material-type-house',
    'suburban-total-area',
    'floors-count-house',
    'bedrooms-count',
    'beds-count',
    'visual-divider',
    'wc-location-type',
    'heating-type-house',
    'visual-divider',
    'repair-type',
    'in-house-rent',
    'area-land',
  ],
  'price-and-deal-terms': [
    'price-rent-daily',
    'bargain-daily',
    'deposit',
    'self-employed',
  ],
};
